import { __rest } from "tslib";
import { EssentialsPartialDelegate } from './EssentialsPartialDelegate';
export class ChildEssentials {
    constructor(_a) {
        var { parent } = _a, options = __rest(_a, ["parent"]);
        this.createChildEssentials = (options = {}) => {
            return new ChildEssentials(Object.assign(Object.assign({}, options), { parent: this }));
        };
        this._parent = parent;
        this._delegate = new EssentialsPartialDelegate(Object.assign(Object.assign({}, options), { parent: this._parent }));
    }
    get asPartial() {
        return this._delegate;
    }
    get experiments() {
        return this._delegate.getExperiments(this._parent);
    }
    get fedopsLogger() {
        return this._delegate.getFedopsLogger(this._parent);
    }
    get errorMonitor() {
        return this._delegate.getErrorMonitor(this._parent);
    }
    get i18n() {
        return this._delegate.getI18n(this._parent);
    }
    get biLoggerFactory() {
        return this._delegate.getBILoggerFactory(this._parent);
    }
    get httpClient() {
        return this._delegate.getHttpClient(this._parent);
    }
    get dataCapsule() {
        return this._delegate.getDataCapsule(this._parent);
    }
    get createCurrencyFormatter() {
        return this._delegate.getCreateCurrencyFormatter(this._parent);
    }
    get formatAddress() {
        return this._delegate.getFormatAddress(this._parent);
    }
    get environment() {
        return this._parent.environment;
    }
}
//# sourceMappingURL=ChildEssentials.js.map